import taskTypes from 'options/tasks/taskTypes'
import FormView from 'components/Tasks/FormView'

const Component = (props) => (
  <FormView taskType={taskTypes.ScheduledJob} settingsType={props.settingsType ?? 'jobs'} {...props} />
)

export default Component
